import styled from 'styled-components';

export const IndexContainer = styled.div`
  .tab-area-head {
    color: #ffffff;
    font-size: 33px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 46px;
    margin-bottom: 30px;
  }
  .tab-side-head {
    color: #ff4552;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.18px;
    line-height: 34px;
    text-align: right;
  }
  .tab-content-area p {
    color: #ffffff;
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
  }
  .single-tab-area {
    padding: 173px 0;
    position: relative;
  }
  .tab-box-area {
    border: 1px solid #fff;
    min-height: 280px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 228px;
    position: relative;
    margin: 15px 0;
  }
  .tab-box-area-main {
    padding: 95px 0 0;
  }
  .tab-box-desc,
  .tab-box-icon {
    opacity: 1;
    transition: 0.3s all ease-in-out;
    width: 100%;
    text-align: center;
  }
  .tab-box-area:hover .tab-box-desc,
  .tab-box-area:hover .tab-box-icon {
    opacity: 0;
  }
  .tab-box-desc h3 {
    color: #ffffff;
    font-size: 25px;
    font-weight: bold;
    letter-spacing: -0.2px;
    line-height: 30px;
    margin: 40px 0 0;
  }
  .tab-hidden-desc p {
    color: #181726;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.1px;
    line-height: 22px;
    margin: 0;
  }
  .tab-hidden-desc {
    position: absolute;
    padding: 5px 35px;
    background-color: #ff4552;
    height: 100%;
    width: 100%;
    transition: 0.3s all ease-in-out;
    opacity: 0;
    transform: translateX(0) translateY(0);
    display: flex;
    flex-direction: column;
    top: 0;
    bottom: 0;
    text-align: left;
    justify-content: center;
    z-index: -1;
  }
  .tab-box-area:hover .tab-hidden-desc {
    opacity: 1;
    transform: translateX(10px) translateY(-10px);
    z-index: 1;
  }
  .tab-hidden-desc h4 {
    font-family: 'Be Vietnam Pro';
    color: #000000;
    font-size: 15px;
    font-weight: bold;
    letter-spacing: -0.11px;
    line-height: 24px;
  }
  .tab-hidden-desc i {
    color: #fff;
    font-size: 24px;
    margin-top: 30px;
    transition: all 0.2s;

    &:hover {
      transform: translateX(5px);
    }
  }

  .we-empower-main {
    padding: 120px 0;
    position: relative;
  }
  .we-empower-main .rotated-tab-txt p::after {
    background-color: #0a090b;
  }
  .we-empower-desc h4 {
    color: #000000;
    font-size: 32px;
    letter-spacing: -0.24px;
    line-height: 44px;
  }
  .we-empower-desc p {
    color: #0a090b;
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
  }
  .we-empower-desc .read-more-btn {
    margin-top: 89px;
  }
  .we-empower-main .rotated-tab-txt {
    bottom: 546px;
    top: auto;
    left: -167px;
  }
  .solutions-block .big-heading {
    text-align: right;
    position: relative;
    z-index: 9;
    margin-bottom: 55px;
  }
  .solution-tab-result-area {
    background-color: #ff4552;
    padding: 94px 70px;
    position: relative;
  }
  .solution-tab-bg-img {
    height: 358px;
    width: 370px;
    top: -135px;
    right: -125px;
  }
  .solution-tab-result-area h3 {
    color: #ffffff;
    font-size: 32px;
    font-weight: 600;
    letter-spacing: -0.24px;
    line-height: 44px;
  }
  .solution-tab-result-area p {
    color: #ffffff;
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
    margin: 0;
  }
  .solution-tab-result-area .deep-blue-btn {
    margin-top: 29px;
  }
  .rotated-solution-txt {
    transform: rotate(90deg);
    position: absolute;
    right: -73px;
    top: 200px;

    h4 {
      color: #0a090b;
      font-size: 24px;
      font-weight: bold;
      letter-spacing: -0.18px;
      line-height: 34px;
      margin: 0;
    }
  }

  .solution-tab-list {
    list-style-type: none;

    li {
      margin-bottom: 25px;

      a {
        color: #000000;
        font-size: 22px;
        font-weight: bold;
        letter-spacing: -0.16px;
        line-height: 34px;
        position: relative;
        display: inline-block;
        cursor: pointer;
        background: none;
        border: 0;
        outline: 0;
        text-align: left;

        &::after {
          background-color: #ff4552;
          position: absolute;
          bottom: 0;
          left: 0;
          height: 3px;
          width: 0;
          content: '';
          transition: 0.3s all ease-in-out;
        }

        &:hover,
        &.active {
          color: #ff4552;

          &::after {
            width: 100%;
          }
        }
      }
    }
  }

  .solutions-main {
    padding: 140px 0 70px;
    position: relative;
    background-color: #fafafa;
  }
  .video-desc-area h3 {
    color: #ffffff;
    font-size: 31px;
    font-weight: 600;
    letter-spacing: -0.24px;
    line-height: 44px;
  }
  .video-desc-area p {
    color: #ffffff;
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
  }
  .video-desc-area .read-more-btn {
    color: #fff;
    margin-top: auto;
    max-width: 230px;
    text-align: center;
  }
  .video-desc-area {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .video-area-main {
    padding: 40px 0;
    position: relative;
  }

  .single-testimonial h5 {
    color: #ffffff;
    font-size: 36px;
    font-weight: 900;
    line-height: 52px;
    text-align: center;
    padding: 0 30px 35px;
  }
  .testimonial-info p {
    color: #ffffff;
    font-size: 18px;
    line-height: 28px;
    text-align: left;
    display: inline-block;
    margin-left: 15px;
    margin-bottom: 0;
  }
  .testimonial-info p span {
    font-size: 16px;
  }
  .testimonial-info {
    text-align: center;
  }
  .testimonial-block {
    position: relative;
    margin-bottom: 260px;
  }
  .testimonial-block .rotated-tab-txt {
    left: -110px;
    top: 55%;
  }

  .white-paper-floating-text {
    position: absolute;
    top: -50px;
    left: calc(50% + 160px);
    transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.05);
    font-family: 'Be Vietnam Pro', sans-serif;
    font-size: 158px;
    font-weight: 900;
    letter-spacing: 12px;
    line-height: 33px;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
  }

  .white-paper-area h3 {
    color: #000000;
    font-size: 33px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 46px;
    margin-bottom: 0;
  }
  .white-paper-area p {
    margin-bottom: 35px;
    font-size: 16px;
  }
  .white-paper-area {
    background-color: #fff;
    padding: 46px 40px 46px 50px;
    margin-bottom: 150px;
  }

  .talk-form {
    .hs-form-field {
      max-width: unset;
      margin-bottom: 35px;
    }

    label {
      color: #fff;

      &.hs-error-msg {
        color: #000000;
      }
    }

    option {
      color: #000000;

      &:disabled {
        opacity: 0.5;
      }
    }

    .hs-input {
      width: 100% !important;
    }

    .hs-error-msgs {
      list-style: none;
      font-weight: bold;
      margin-top: 10px;
    }
  }

  .solution-rel {
    margin-top: 80px;
  }

  @media (max-width: 1200px) {
    .solution-tab-bg-img {
      top: -105px;
      right: -75px;
    }
    .solution-tab-result-area {
      padding: 34px 30px;
    }
    .rotated-solution-txt {
      top: 78%;
    }
  }

  @media (max-width: 990px) {
    .tab-box-area {
      width: 100%;
    }
    .solutions-main {
      padding: 50px 0 59px 0;
    }
    .video-desc-area {
      margin-top: 25px;
    }
    .testimonial-block {
      margin-bottom: 90px;
    }
  }

  @media (max-width: 767px) {
    .single-tab-area {
      padding: 20px 0 45px;
    }
    .tab-area-head {
      font-size: 22px;
      line-height: 33px;
    }
    .tab-side-head {
      display: none;
    }
    .tab-content-area p {
      font-size: 16px;
      line-height: 24px;
    }
    .tab-box-area-main {
      padding: 35px 0 0;
    }
    .tab-hidden-desc {
      position: static;
      opacity: 1;
      background-color: transparent;
    }
    .tab-box-desc h3 {
      margin: 0;
    }
    .tab-hidden-desc h4,
    .tab-hidden-desc h5 {
      color: #fff;
    }
    .tab-hidden-desc p {
      color: #fff;
    }
    .tab-box-area {
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
      border: none;
      justify-content: left;
      min-height: 10px;
      margin: 0 0 40px;
    }
    .tab-box-icon {
      position: relative;
      top: 15px;
    }
    .tab-box-desc,
    .tab-box-icon {
      opacity: 1;
      transition: 0.3s all ease-in-out;
      width: 100%;
      width: 50px;
    }
    .tab-hidden-desc {
      position: static;
      opacity: 1;
      background-color: transparent;
      flex: auto;
      width: 100%;
      display: block;
      padding: 0 0 0 70px;
      height: auto;
      z-index: 1;
    }
    .tab-hidden-desc h5 {
      color: #fff;
      margin: 0 0 5px;
    }
    .tab-hidden-desc p {
      color: #fff;
    }
    .tab-box-desc h3 {
      margin: 0;
      text-align: left;
    }
    .tab-box-desc {
      flex: 1;
      padding-left: 15px;
    }
    .tab-hidden-desc i {
      display: none;
    }
    .tab-box-area:hover .tab-box-desc,
    .tab-box-area:hover .tab-box-icon {
      opacity: 1;
    }
    .tab-box-area:hover .tab-hidden-desc {
      transform: none;
    }
    .we-empower-desc h4 {
      font-size: 22px;
      line-height: 31px;
      margin-top: 25px;
    }
    .we-empower-desc .read-more-btn {
      margin-top: 52px;
      background-color: #ff4552;
      color: #fff;
    }
    .we-empower-main {
      padding: 50px 0;
    }
    .solutions-block .big-heading {
      text-align: left;
      margin-bottom: 55px;
    }
    .solution-rel {
      display: none;
    }
    .solution-tab-list li h4 {
      color: #000000;
      font-family: 'Be Vietnam Pro';
      font-size: 20px;
      font-weight: 600;
      line-height: 34px;
      margin: 15px 0 8px;
    }
    .solution-tab-list li span::after {
      background-color: #000;
      width: 100%;
      bottom: auto;
      top: 0;
    }
    .solution-tab-list li span {
      display: block;
      padding: 15px 0;
      color: #000000;
      font-family: Vollkorn;
      font-size: 30px;
      font-weight: bold;
      line-height: 42px;
    }
    .mob-arrow {
      height: 56px;
      width: 56px;
      display: inline-block;
      background-color: #ff4552;
      text-align: center;
      line-height: 56px;
      font-size: 21px;
      border-radius: 50%;
      color: #fff;
      margin-bottom: 25px;
    }
    .solution-tab-list li {
      margin-bottom: 0;

      &.mobile-hide {
        display: none;
      }
    }
    .solution-tab-open span:after {
      background-color: #ff4552 !important;
    }
    .black-btn-mob {
      padding: 16px;
      background-color: #000;
      text-align: center;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;
      text-transform: uppercase;
    }
    .solution-tab-list {
      list-style-type: none;
      margin-bottom: 45px;
    }
    .video-desc-area h3 {
      font-size: 22px;
      line-height: 31px;
    }
    .single-testimonial h5 {
      padding: 0;
      font-size: 22px;
      line-height: 31px;
    }
    .white-paper-area h3 {
      font-size: 22px;
      line-height: 31px;
      margin-bottom: 35px;
      text-align: center;
    }
    .white-paper-area {
      padding: 36px 20px;
      margin-bottom: 70px;
      text-align: center;
    }
    .video-area-main {
      overflow: hidden;
      padding: 40px 0 90px;
    }
  }
`;
